module.exports = __webpack_public_path__ + "img/ziji.0e369f03.png";